import { VerificationStatusResponseDto } from '../dto/response/verification-status-response.dto';
import { VerificationStatusSaveRequestDto } from '../dto/request/verification-status-save-request.dto';
import { VerificationStatusUpdateRequestDto } from '../dto/request/verification-status-update-request.dto';
import { BaseLandscapeService } from '../../base-landscape.service';
import {
  getLanguageKey,
  LocalesLanguagesConstants,
} from '../../../../locales/locales';

class VerificationStatusService extends BaseLandscapeService {
  public async fetchVerificationStatuses(): Promise<
    VerificationStatusResponseDto[]
  > {
    const response =
      await this.get<VerificationStatusResponseDto[]>(`/verificationstatus`);
    return response.data;
  }

  public async fetchVerificationStatusById(
    id: string,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<VerificationStatusResponseDto> {
    const response = await this.get<VerificationStatusResponseDto>(
      `/verificationstatus/${id}`,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async saveVerificationStatus(
    saveRequest: VerificationStatusSaveRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<VerificationStatusResponseDto> {
    const response = await this.post<VerificationStatusResponseDto>(
      `/verificationstatus`,
      saveRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async updateVerificationStatus(
    updateRequest: VerificationStatusUpdateRequestDto,
    language: LocalesLanguagesConstants = LocalesLanguagesConstants.en
  ): Promise<VerificationStatusResponseDto> {
    const response = await this.put<VerificationStatusResponseDto>(
      `/verificationstatus`,
      updateRequest,
      {
        headers: {
          'accept-language': getLanguageKey(language),
        },
      }
    );
    return response.data;
  }

  public async deleteVerificationStatus(existingId: string): Promise<void> {
    await this.delete<void>(`/verificationstatus/${existingId}`);
  }
}

const verificationStatusService = new VerificationStatusService();
export default verificationStatusService;
